import React, { useEffect } from "react";
import { Select, Input, Form,Icon } from "antd";
import BankSelectCon from '$Deposits/Components/Components/BankSelect'
import { bankCodeWriting } from '$Deposits/lib/LibCommonData'
import { translate } from "$ACTIONS/Translate";
import { connect } from "react-redux";

const { Option } = Select;
const { Item } = Form;
class BankSelect extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        };

    }

    componentDidUpdate(prevProps, prevState) {

    }
    componentDidMount() {

    }
    componentWillUnmount() {

    }


    render() {



        return (
            <>
                <BankSelectCon
                    BankSelect={(propCon) => {
                        const {
                            BankList,
                            DepositBankActive,
                            onChange,
                            onChangeSearch,
                            searchValue,
                            LivechatClick,
                        } = propCon
                        return (
                            <>
                                {/*  普通银行选择 */}
                                <BankDrawerComponent
                                    BankList={BankList}
                                    DepositBankActive={DepositBankActive}
                                    onChange={onChange}
                                    onChangeSearch={onChangeSearch}
                                    searchValue={searchValue}
                                    LivechatClick={LivechatClick}
                                />
                            </>
                        )
                    }}
                    PHCbankList={(propCon) => {
                        const {
                            BankList,
                            DepositBankActive,
                            onChange,
                            MethodsDetails,
                        } = propCon
                        const { code, name } = DepositBankActive
                        const { charges } = MethodsDetails && MethodsDetails.setting || {}
                        return (
                            <>
                                <p className="inputTitle">Chọn Thẻ Cào</p>
                                <div className="PHCbankList">
                                    {
                                        BankList.map((item, index) => {
                                            return (
                                                <div
                                                    key={index}
                                                    className={item.code == code ? 'PHCbankItem PHCbankItemActive' : 'PHCbankItem'}
                                                    onClick={() => { onChange(item) }}
                                                >
                                                    <div className={'PHC-' + item.code} />
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                                {
                                    charges && charges != 0 &&
                                    <div className="PHC-charges">
                                        Phí nạp tiền của thẻ cào {name || ""} là {Math.abs(charges) * 100}%
                                    </div>
                                }
                            </>
                        )
                    }}
                    CHANNEL={(propCon) => {
                        const {
                            BankList,
                            DepositBankActive,
                            onChange,
                        } = propCon
                        const { code } = DepositBankActive
                        return (
                            <>
                                <p className="inputTitle">Chọn Tiền Mã Hóa</p>
                                <div className="CTCList">
                                    {
                                        BankList.map((item, index) => {
                                            return (
                                                <div
                                                    key={index}
                                                    className={`${item.code == code ? "CTCListItemActive" : "CTCListItem" } ${item.code==="USDT-TRC20"?"usdt-trc20":""}`}
                                                    onClick={() => { onChange(item) }}
                                                >
                                                    <div className={item.code + 'Icon'} />
                                                    <p>
                                                        <p>{`Tether USD`}</p>
                                                        <p>{item.code}</p>
                                                    </p>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </>
                        )
                    }}

                />

            </>
        );
    }
}

class BankDrawer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            setBankCard: {
                searchValue: "",
                showBankList: false,
                bankAlphabetic: "",
                enBankName:""
            },
        };
        this.wrapperRef = React.createRef();
    }
    componentDidMount(){
        const bank = this.props.DepositBankActive;
        if(bank?.bankName||bank?.name){
            this.setState({
                setBankCard: {
                    searchValue: bank.bankName || bank.name,
                    enBankName: bank.enBankName || bank.englishName
                }
            })
        }
        document.addEventListener('mousedown', this.handleClickOutside);
    }
    componentDidUpdate(prevProps, prevState){
        if(prevProps.DepositBankActive !== this.props.DepositBankActive && this.props.DepositBankActive){
            const bank = this.props.DepositBankActive;
            if(bank?.bankName||bank?.name){
                this.setState({
                    setBankCard: {
                        searchValue: bank.bankName || bank.name,
                        enBankName: bank.enBankName || bank.englishName
                    }
                })
            }
        }
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleClickOutside = (event) => {
        try {
            if (this.wrapperRef && !this.wrapperRef?.current.contains(event.target)) {
                this.setState(prevState => ({
                    setBankCard: {
                        ...prevState.setBankCard,
                        showBankList: false
                    }
                }));
            }
        }
        catch {
            console.log("")
        }
    }

    openMenu = () => {
        this.setState(prevState => ({
            setBankCard: {
                ...prevState.setBankCard,
                showBankList: !prevState.setBankCard.showBankList
            }
        }));
    }

    handleSelectChange = (v, option) => {
        const bank = this.props.BankList.find((item) => item.bankId == v);
        this.props.onChange(bank);
        this.setState({
            setBankCard: {
                searchValue: bank?.bankName || bank?.name,
                showBankList: false,
                bankAlphabetic: option.props.children[0].props.src,
                enBankName: bank?.enBankName || bank?.englishName || ""
            }
        })
    }
    render() {
        const {setBankCard} = this.state;
        const {
            BankList,
            DepositBankActive,
            LivechatClick
        } = this.props
        const { bankId, code } = DepositBankActive || {}
        return (
            <>
                {BankList.length > 0 && (
                    <Item label={'Chọn Ngân Hàng FUN88'} className="bankSelect-warp" data-CN="选择FUN88银行">
                        <div ref={this.wrapperRef}>
                            <Input 
                                onClick={this.openMenu}
                                className={`bankNamewrap ${setBankCard.searchValue ? "have" : ""} ${setBankCard.showBankList ? "active" : "inactive"}`}
                                size="large"
                                autoComplete="off"
                                readOnly={true}
                                value={setBankCard.searchValue}
                                placeholder="Chọn ngân hàng"
                                prefix={
                                    setBankCard.searchValue ? (
                                        <span className={'bankIcon-default bankIcon-' + bankCodeWriting(setBankCard.enBankName)} />
                                    ) : (
                                        <span />
                                    )
                                }
                                suffix={
                                    <Icon
                                        type={`${!setBankCard.showBankList ? "caret-down" : "caret-up"}`}
                                        onClick={this.openMenu}
                                    />
                                }
                            />
                            {setBankCard.showBankList && (
                                <div className="drop-area fun-88">
                                    <Select
                                        dropdownAlign={{ overflow: { adjustX: false, adjustY: false } }}
                                        size="large"
                                        onChange={this.handleSelectChange}
                                        getPopupContainer={() => document.querySelector(".drop-area.fun-88")}
                                        className="bankNameSelect"
                                        showArrow={false}
                                        showSearch={true}
                                        optionFilterProp="children"
                                        filterOption={(input, option) => {
                                            const foundBank = BankList.find(item => item.bankId == option?.props?.value);
                                            const bankName = foundBank ? foundBank.bankName || foundBank.name : undefined;
                                            return bankName ? bankName.toLowerCase().includes(input.toLowerCase()) : null;
                                        }}
                                        placeholder={
                                            <div className="searchwrap">
                                                <Icon type="search" style={{ fontSize: 16, marginRight: 6 }} />
                                                <span data-CN="搜索">Tìm kiếm</span>
                                            </div>
                                        }
                                        open={setBankCard.showBankList}
                                        dropdownStyle={{
                                            borderTopLeftRadius: 0,
                                            borderTopRightRadius: 0,
                                        }}
                                        notFoundContent={
                                            <div className="not-found-content">
                                                <div className="nofoundimg"></div>
                                                <p>không có dữ liệu</p>
                                            </div>
                                        }
                                        onSelect={() => this.setState(prevState => ({
                                            setBankCard: { ...prevState.setBankCard, showBankList: false }
                                        }))}
                                    >
                                        {BankList.map((value, index) => (
                                            <Option className={bankId == value.bankId ? "ant-select-dropdown-menu-item-selected" : ""} value={value.bankId} key={index + value.bankId}>
                                                <span className={'bankIcon-default bankIcon-' + bankCodeWriting(value.enBankName || value.englishName)} />
                                                {value.bankName || value.name || "Liên hệ dịch vụ khách hàng"}
                                            </Option>
                                        ))}
                                    </Select>
                                </div>
                            )}
                        </div>
                    </Item>
                )}
                {this.props.MethodsActive?.code == 'FP' && code == 'VCB' &&
                    <div className="vnMoneyTip">Lưu Ý: Đối với ngân hàng VIETCOMBANK, xin vui lòng sử dụng TÀI KHOẢN NGÂN HÀNG TRỰC TUYẾN để chuyển khoản. </div>
                }
                {
                    BankList.length == 0 &&
                    <div onClick={LivechatClick} className="liveChatBtn" disabled data-CN="目前無可收款存款銀行，請聯絡客服">
                        Xin vui lòng liên hệ với dịch vụ khách hàng
                    </div>
                }
            </>
        );
    }
}

const mapStateToProps = state => ({
    MethodsActive: state.MethodsActive,
});
const BankDrawerComponent = connect(mapStateToProps,null)(BankDrawer);
export default BankSelect









